import styled from "styled-components";
import { TableWrapperStyled } from "styles/common.styles";
import { tmTableHeaderAlignmentStyles } from "../sharedTable.styles";

export const InfoCardStyled = styled.div`
  display: flex;
  gap: 32px;
  padding: 14px 24px;
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};
  border-bottom: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
`;

export const InfoStatStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  .label {
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  }
  .value {
    font-size: 18px;
    font-weight: 700;
  }
`;

// Extends the shared TableWrapperStyled (flex-grow + overflow-y: auto) so
// this is the page's one scrollable area — PageContainerStyled clips at
// overflow: hidden, so without it a tall table or an expanded at-risk panel
// is cut off with no scrollbar. Header and info card stay pinned above,
// same pattern as the other V2 pages.
// The cutoff-row class comes via SbTable's rowClassName and marks the last
// row still inside the target headcount — everyone after it is "at risk."
// While that row is expanded it gets cutoff-row-expanded instead, and the
// dashed line is drawn under its next-roles panel.
export const ReductionTableWrapperStyled = styled(TableWrapperStyled)`
  .ant-table-tbody > tr {
    cursor: pointer;
  }
  .cutoff-row > td,
  .cutoff-row-expanded + .ant-table-expanded-row > td {
    border-bottom: 2px dashed ${(p) => p.theme?.colors?.primary ?? "#008080"} !important;
  }

  /* Same filter/sort-icon-next-to-label + opt-in header-centering fix as
     sharedTable.styles.js's ClickableTableWrapperStyled — this table has its
     own wrapper (it needs the cutoff-row rule above, which that shared one
     doesn't have) so it can't extend it, but the rules themselves are
     identical and shared from there. */
  ${tmTableHeaderAlignmentStyles}
`;

export const SuggestedRolesWrapperStyled = styled.div`
  padding: 12px 20px;
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};

  .nested-title {
    font-size: 12.5px;
    font-weight: 700;
    margin-bottom: 8px;
  }
`;

export const SuggestedRoleRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  font-size: 12.5px;

  &:not(:last-child) {
    border-bottom: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#EEF1F5"};
  }
`;
